import * as React from 'react';
import Typography from '@mui/material/Typography';
import { 
  Alert, 
  Box, 
  Button, 
  Container, 
  Paper, 
  Snackbar, 
  Card, 
  CardContent, 
  Divider, 
  Chip,
  IconButton,
  Tooltip
} from '@mui/material';
import { 
  ArrowBack, 
  Person, 
  Business, 
  Badge, 
  Email, 
  Phone, 
  AccessTime, 
  CheckCircle, 
  Pending, 
  Cancel 
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios';
import { url } from '../utils/constants';
import { LoaderOverlay } from '../utils/components';
import { useAuth } from '../../contexts/AuthContext';




// Styled Components
const ModernButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#1976D2',
  color: 'white',
  fontWeight: 600,
  borderRadius: 12,
  padding: '12px 24px',
  textTransform: 'none',
  fontSize: '1rem',
  boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
  '&:hover': {
    backgroundColor: '#1565C0',
    boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
    transform: 'translateY(-2px)',
  },
  transition: 'all 0.3s ease',
}));

const ModernCard = styled(Card)(({ theme }) => ({
  backgroundColor: 'rgba(255,255,255,0.95)',
  backdropFilter: 'blur(10px)',
  borderRadius: 16,
  boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
  border: '1px solid rgba(255,255,255,0.2)',
}));

export default function PerfilDetalhado({ usePageTitle }) {
  usePageTitle('PixTick | Perfil detalhado');
  const id = useLocation().pathname.split('/').pop();
  const [perfil, setPerfil] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [copied, setCopied] = React.useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();


  React.useEffect(() => {
    async function fetchData() {
      try {
        const token = await localStorage.getItem('token');
        //console.log('teste> ' + token);
        const response = await axios.get(url + `/api/v1/user/perfil/${id}`, {
          headers: ({
            Authorization: 'Bearer ' + token
          })
        });
        const { data } = response.data;
        setPerfil(data);

        console.log(data);

        // Dados carregados com sucesso
      } catch {
        logout();
        navigate('/signin');
      } finally {
        setLoading(false);
        //console.log(transactions);

      }

    }
    fetchData();
  }, [navigate, logout, perfil._id, id]);


  function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return phoneNumber;

    // Definir máscaras para cada DDI
    const masks = {
      '+55': { name: 'Brasil', mask: '(xx) xxxxx-xxxx' },
      '+54': { name: 'Argentina', mask: '(x) xxxx xx-xxxx' },
      '+595': { name: 'Paraguai', mask: '(xxx) xxx-xxx' },
      '+1': { name: 'EUA', mask: '(xxx) xxx-xxxx' }
      // Adicione outras máscaras conforme necessário
    };

    // Detectar o DDI do número de telefone
    let ddi = Object.keys(masks).find(ddi => phoneNumber.startsWith(ddi));
    if (!ddi) return phoneNumber; // Se não for encontrado nenhum DDI correspondente, retorne o número de telefone sem formatação
    phoneNumber = phoneNumber.replace(ddi, ''); // Remover o DDI do número de telefone
    // Obter a máscara correspondente ao DDI detectado
    const mask = masks[ddi].mask;

    // Remover caracteres não numéricos do número de telefone
    const numericPhoneNumber = phoneNumber.replace(/\D/g, '');

    // Aplicar máscara ao número de telefone
    let formattedPhoneNumber = '';
    let maskIndex = 0;
    for (let i = 0; i < mask.length && maskIndex < numericPhoneNumber.length; i++) {
      if (mask[i] === 'x') {
        formattedPhoneNumber += numericPhoneNumber[maskIndex];
        maskIndex++;
      } else {
        formattedPhoneNumber += mask[i];
      }
    }
    //ddi + formattedPhoneNumber;

    return ddi + ' ' + formattedPhoneNumber;
  }



  function getStatusConfig(status) {
    switch (status) {
      case 'EMANALISE':
        return { 
          color: 'info', 
          backgroundColor: '#1976D2', 
          icon: <Pending />, 
          label: 'EM ANÁLISE' 
        };
      case 'ATIVO':
        return { 
          color: 'success', 
          backgroundColor: '#4CAF50', 
          icon: <CheckCircle />, 
          label: 'ATIVO' 
        };
      case 'Concluído':
        return { 
          color: 'primary', 
          backgroundColor: '#2196F3', 
          icon: <CheckCircle />, 
          label: 'CONCLUÍDO' 
        };
      case 'Falhou':
        return { 
          color: 'error', 
          backgroundColor: '#F44336', 
          icon: <Cancel />, 
          label: 'FALHOU' 
        };
      default:
        return { 
          color: 'error', 
          backgroundColor: '#F44336', 
          icon: <Cancel />, 
          label: status || 'DESCONHECIDO' 
        };
    }
  }


  const handleVoltar = () => {
    navigate('/perfis');
  }

  const statusConfig = getStatusConfig(perfil.status);

  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        backgroundColor: '#FFFFFA',
        paddingTop: { xs: 8, md: 10 },
        paddingBottom: { xs: 2, md: 3 }
      }}
    >
      <LoaderOverlay loading={loading} />
      
      <Container maxWidth="md">
        {/* Header */}
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2, 
            mb: 3,
            backgroundColor: 'white',
            borderRadius: 3,
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            padding: 2
          }}
        >
          <IconButton 
            onClick={handleVoltar}
            sx={{ 
              backgroundColor: '#1976D2',
              color: 'white',
              '&:hover': { backgroundColor: '#1565C0' }
            }}
          >
            <ArrowBack />
          </IconButton>
          <Typography 
            variant="h4" 
            component="h1"
            sx={{ 
              fontWeight: 700,
              fontFamily: 'Ubuntu, sans-serif',
              color: '#1976D2',
              fontSize: { xs: '1.5rem', md: '2rem' }
            }}
          >
            Detalhes do Perfil
          </Typography>
        </Box>

        {!loading && (
          <ModernCard elevation={4}>
            <CardContent sx={{ p: { xs: 2, md: 3 } }}>
              {/* Status Chip */}
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                <Chip
                  icon={statusConfig.icon}
                  label={statusConfig.label}
                  color={statusConfig.color}
                  sx={{
                    fontSize: { xs: '0.9rem', md: '1.1rem' },
                    padding: { xs: '8px 16px', md: '12px 24px' },
                    height: 'auto',
                    '& .MuiChip-icon': {
                      fontSize: { xs: '1.2rem', md: '1.5rem' }
                    }
                  }}
                />
              </Box>

              <Divider sx={{ mb: 3 }} />

              {/* Profile Information */}
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 2, 
                    p: 2,
                    backgroundColor: 'rgba(25, 118, 210, 0.05)',
                    borderRadius: 2,
                    border: '1px solid rgba(25, 118, 210, 0.1)'
                  }}>
                    <Person color="primary" />
                    <Box>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
                        Nome
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        {perfil.fullname || '-'}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 2, 
                    p: 2,
                    backgroundColor: 'rgba(25, 118, 210, 0.05)',
                    borderRadius: 2,
                    border: '1px solid rgba(25, 118, 210, 0.1)'
                  }}>
                    <Business color="primary" />
                    <Box>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
                        Empresa
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        {perfil.empresa || '-'}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 2, 
                    p: 2,
                    backgroundColor: 'rgba(25, 118, 210, 0.05)',
                    borderRadius: 2,
                    border: '1px solid rgba(25, 118, 210, 0.1)'
                  }}>
                    <Badge color="primary" />
                    <Box>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
                        CNPJ
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        {perfil.cnpj || '-'}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 2, 
                    p: 2,
                    backgroundColor: 'rgba(25, 118, 210, 0.05)',
                    borderRadius: 2,
                    border: '1px solid rgba(25, 118, 210, 0.1)'
                  }}>
                    <Badge color="primary" />
                    <Box>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
                        IDPDV
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        {perfil.idpdv || '-'}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 2, 
                    p: 2,
                    backgroundColor: 'rgba(25, 118, 210, 0.05)',
                    borderRadius: 2,
                    border: '1px solid rgba(25, 118, 210, 0.1)'
                  }}>
                    <Email color="primary" />
                    <Box>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
                        E-mail
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        {perfil.email || '-'}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 2, 
                    p: 2,
                    backgroundColor: 'rgba(25, 118, 210, 0.05)',
                    borderRadius: 2,
                    border: '1px solid rgba(25, 118, 210, 0.1)'
                  }}>
                    <Phone color="primary" />
                    <Box>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
                        Telefone
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        {perfil.numero ? formatPhoneNumber('+' + perfil.numero) : '-'}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 2, 
                    p: 2,
                    backgroundColor: 'rgba(25, 118, 210, 0.05)',
                    borderRadius: 2,
                    border: '1px solid rgba(25, 118, 210, 0.1)'
                  }}>
                    <AccessTime color="primary" />
                    <Box>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
                        Data / Hora
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        {perfil.createdDate ? new Date(perfil.createdDate).toLocaleDateString('pt-BR', { 
                          day: '2-digit', 
                          month: '2-digit', 
                          year: 'numeric', 
                          hour: '2-digit', 
                          minute: '2-digit', 
                          second: '2-digit' 
                        }) : '-'}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>

              {/* Back Button */}
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <ModernButton onClick={handleVoltar}>
                  VOLTAR
                </ModernButton>
              </Box>
            </CardContent>
          </ModernCard>
        )}
      </Container>

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
      >
        <Alert onClose={() => setCopied(false)} severity="success" sx={{ width: '100%' }}>
          Código copiado!
        </Alert>
      </Snackbar>
    </Box>
  );

}
